var ScrollReveal = require('scrollreveal');

function init(){
 var intro = document.querySelector('.intro .reveal');

 if(intro){
   window.sr = ScrollReveal();
   sr.reveal('.intro .reveal', 500);
   sr.reveal('.landing-benefits', { viewFactor: 0.4, delay: 350, scale: 1});
   sr.reveal('.how-it-works .col-2', {viewFactor: 0.3}, 150);
 }

}

document.addEventListener('DOMContentLoaded', init);